import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bfcbe402"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "trial-expiring-modal__text mb-3" }, " После окончания пробного периода: будет доступно только 3 ученика, функции звонков и онлайн-доски станут недоступны ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "trial-expiring-modal__text mb-3" }, [
  /*#__PURE__*/_createTextVNode(" Если у вас добавлено более 3 учеников и не подключён «Безлимит», ученики сверх лимита будут перемещены в архив. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Все созданные вами доски, станут недоступны но будут сохранены в материалах. ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "trial-expiring-modal__text" }, " Подключите нужные опции, чтобы продолжить работу без ограничений! ", -1))

import { ref } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrialExpiringModal',
  emits: ["hidden", "confirm"],
  setup(__props, { expose: __expose, emit: __emit }) {

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

function onConfirm() {
    emit('confirm');
    hideModal();
}

const emit = __emit;

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

__expose({
    show: showModal,
    hide: hideModal,
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TariffNotificationModal, {
    ref_key: "modalRef",
    ref: modalRef,
    title: "Ваш бесплатный доступ ко всем функциям скоро завершится",
    onButtonClick: onConfirm,
    onHidden: _cache[0] || (_cache[0] = ($event: any) => (emit('hidden'))),
    "button-text": "Подключить",
    "max-width": 450
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }, 512))
}
}

})